import React from 'react';

type WithClassName = {
  className?: string;
};

export function withClassName<T>(Component: React.ComponentType<T>): React.FC<T & WithClassName> {
  return ({ className, ...rest }) => (
    <div className={className}>
      {/* @ts-expect-error idk */}
      <Component {...rest} />
    </div>
  );
}
